@if (loaded) {
@if (error) {
<error-page [errorType]="errorType">
</error-page>
}
@else {
@if (form) {
<metadata-form [form]="form" [initialView]="initialView" [passback]="passback"
    [createNewModelOnLoad]="createNewModelOnLoad" [returnDataOnSave]="true" [newForm]="newForm"
    [navigateBackOnReturn]="navigateBackOnReturn" [closeOnFinish]="closeOnFinish"
    [customViewCommands]="customViewCommands">
</metadata-form>
}
}
} @else {
<busy-indicator [page]="true"></busy-indicator>
}